import React, { Component } from 'react';
import { Tooltip } from 'antd';
import intl from 'react-intl-universal';

class RedoButton extends Component {
    constructor (props) {
        super(props);
        this.state = {
            disabled: true
        };
        this.listeners = [];
    }
    componentDidMount () {
        const PDFUI = this.PDFUI = window.pdfui;
        this.redoManager = {};
        this.listeners = [
            PDFUI.addViewerEventListener(UIExtension.UIEvents.openFileSuccess, () => {
                this.redoManager = {};
                this.setState({disabled: true});
            }),
            PDFUI.addViewerEventListener(UIExtension.UIEvents.undoRedoStoreChange, (undoRedoData, type = 'undoRedo', isEditing) => {
                if (type === 'clearAll') {
                    this.redoManager = {};
                    this.setState({disabled: true});
                    return ;
                }
                if (!undoRedoData) return ;
                let redoStackArray = [];
                if (type === 'touchUp' || type === 'pageEditor') {
                    redoStackArray = undoRedoData[1];
                } else {
                    this.undoRedoController = undoRedoData;
                    const undoRedoManager = undoRedoData.undoRedoManager;
                    redoStackArray = undoRedoManager.redoStack.stackArray;
                }
                if (!redoStackArray) return ;
                if (isEditing !== undefined) {
                    type += isEditing;
                }
                const redoStackArrayCache = this.redoManager[type] || [];
                const _redoStackArrayCache = [];
                redoStackArray.forEach(redoStackItem => {
                    let isItemInCache = false;
                    for (let index = 0; index < redoStackArrayCache.length; index++) {
                        const element = redoStackArrayCache[index];
                        if (
                            ((redoStackItem instanceof Array) && (element.data instanceof Array)) ? 
                            (element.data.join('') === redoStackItem.join('')) : 
                            (element.data === redoStackItem)
                        ) {
                            isItemInCache = true;
                            _redoStackArrayCache.push(element);
                            break;
                        }
                    }
                    if (!isItemInCache) {
                        _redoStackArrayCache.push({
                            type: type,
                            data: redoStackItem,
                            isEditing: isEditing,
                            time: Date.now()
                        });
                    }
                });
                
                this.redoManager[type] = _redoStackArrayCache;
                let total = 0;
                for (const key in this.redoManager) {
                    const info = this.redoManager[key];
                    total += info.length;
                }
                this.setState({disabled: total === 0});
                this.clearRedoData(undoRedoData, type, isEditing);
            })
        ];
        document.body.addEventListener('keyup', this.keyupEvent = (e) => {
            this.addRedoEvent(e);
        });
    }
    componentWillUnmount () {
        document.body.removeEventListener('keyup', this.keyupEvent);
        this.listeners.forEach(destroy => destroy());
    }

    addRedoEvent (e) {
        const { disabled } = this.state;
        if (!disabled && e.shiftKey && e.ctrlKey && e.keyCode === 90) {
            // ctrl + shift + z
            this.handleRedo();
        }
    }

    // 当有新增操作时候，清空redo数据
    clearRedoData (undoRedoData, type) {
        let undoStack, redoStack;
        if (!this.prevCache) this.prevCache = {};
        const prevTotal = this.prevCache[type] || 0;
        if (type === 'touchUp' || type === 'pageEditortrue' || type === 'pageEditorfalse') {
            undoStack = undoRedoData[0];
            redoStack = undoRedoData[1];
        } else {
            const undoRedoManager = undoRedoData.undoRedoManager;
            undoStack = undoRedoManager.undoStack.stackArray;
            redoStack = undoRedoManager.redoStack.stackArray;
        }
        const total = undoStack.length + redoStack.length;
        if (prevTotal && total > prevTotal) {
            const PDFUI = this.PDFUI = window.pdfui;
            const doc = PDFUI.pdfViewer.currentPDFDoc;
            for (const key in this.redoManager) {
                const array = this.redoManager[key];
                if (array && array.length > 0) {
                    if (key === 'undoRedo') {
                        this.undoRedoController.undoRedoManager.getRedoStack().clear();
                    } else if (key === 'touchUp') {
                        doc.api.handleTouchUpEvent.apply(doc.api, [doc.id, 'ClearRedo']);
                    } else {
                        doc.api.handlePageEditorEvent.apply(doc.api, [doc.id, 'ClearRedo', undefined, false]);
                    }
                    this.redoManager[key] = [];
                    this.prevCache[key] -= array.length;
                }
            }

            this.setState({disabled: true});
        }
        this.prevCache[type] = total;
    }

    handleRedo () {
        let lastData;
        for (const key in this.redoManager) {
            const array = this.redoManager[key];
            array.forEach(item => {
                const time = item.time;
                if (lastData) {
                    (lastData.time < time) && (lastData = item);
                } else {
                    lastData = item;
                }
            });
        }
        switch (lastData.type) {
            case 'touchUp': 
                this.PDFUI.getCurrentPDFDoc().then(doc => {
                    const touchup = doc.getTouchup();
                    touchup.handleEvent('Undo', false);

                });
                break;
            case 'pageEditortrue':
            case 'pageEditorfalse':
            case 'pageEditor': 
                this.PDFUI.getCurrentPDFDoc().then(doc => {
                    const pageEditor = doc.getPageEditor();
                    pageEditor.undoRedo(lastData.isEditing, false);
                    const currentStatesName = this.PDFUI.pdfViewer.getStateHandlerManager().getCurrentStates().getStateName();
                    if (currentStatesName === 'touch-up-editor') {
                        this.PDFUI.eventEmitter.emit('restartTouchup');
                    }
                });
                break;
            case 'undoRedo':
                const undoRedoController = this.undoRedoController;
                undoRedoController && undoRedoController.redo();
                break;
        }
    }

    render () {
        const { disabled } = this.state;
        return (
            <Tooltip title={intl.get('HeaderContainer.redo')}>
                <i className={`icon-btn ${this.props.className} ` + (disabled ? ' disabled' : '')} style={{'textAlign': 'center', 'paddingTop': '4px'}} onClick={()=>!disabled&&this.handleRedo()}>
                    {this.props.icon ? <img src={this.props.icon} /> : <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.502 14H10.502C10.2259 14 10.002 14.2239 10.002 14.5C10.002 14.7761 10.2259 15 10.502 15H12.502C12.7782 15 13.002 14.7761 13.002 14.5C13.002 14.2239 12.7782 14 12.502 14Z" fill="currentColor"/>
                        <path d="M9 2H11V3H9.224C5.793 3 3 5.47 3 8.5C3 11.53 5.793 14 9.224 14H11V15H9C7.21103 15.0617 5.47041 14.4125 4.15868 13.1945C2.84696 11.9765 2.07084 10.2886 2 8.5C2.07084 6.71137 2.84696 5.02354 4.15868 3.80551C5.47041 2.58748 7.21103 1.93833 9 2Z" fill="currentColor"/>
                        <path d="M10.999 2H13.499C13.7752 2 13.999 2.22386 13.999 2.5C13.999 2.77614 13.7752 3 13.499 3H10.999V2Z" fill="currentColor"/>
                        <path d="M13.1455 2.85355C13.3407 3.04882 13.6573 3.04882 13.8526 2.85355C14.0478 2.65829 14.0478 2.34171 13.8526 2.14645L13.1455 2.85355ZM11.8526 0.146447C11.6573 -0.0488155 11.3407 -0.0488155 11.1455 0.146447C10.9502 0.341709 10.9502 0.658291 11.1455 0.853553L11.8526 0.146447ZM13.8526 2.14645L11.8526 0.146447L11.1455 0.853553L13.1455 2.85355L13.8526 2.14645Z" fill="currentColor"/>
                        <path d="M11.1455 4.14645C10.9502 4.34171 10.9502 4.65829 11.1455 4.85355C11.3407 5.04882 11.6573 5.04882 11.8526 4.85355L11.1455 4.14645ZM13.1455 2.14645L11.1455 4.14645L11.8526 4.85355L13.8526 2.85355L13.1455 2.14645Z" fill="currentColor"/>
                    </svg>}
                </i>
            </Tooltip>
        );
    }
}

export default RedoButton;
